module.exports = __webpack_public_path__ + "img/07.7d7cbcf5.jpg";